import { FooterProps } from '../../Footer/footer.props'

export const footerData: FooterProps = {
  menus: [
    {
      label: 'Научи повече за нас',
      url: '#',
      items: [
        {
          label: 'За Хиполенд',
          url: '/about-hippoland',
        },
        {
          label: 'Блог',
          url: '/blog',
        },
        {
          label: 'Нашите магазини',
          url: '/stores',
        },
        {
          label: 'Контакти',
          url: '/contacts',
        },
        {
          label: 'Често задавани въпроси',
          url: '/faq',
        },
        {
          label: 'Общи условия за Хипо Лего Клуб',
          url: '/obshti-usloviya-za-hipo-lego-klub',
        },
      ],
    },
    {
      label: 'Ако пазаруваш онлайн',
      url: '#',
      isCentered: true,
      contentMaxWidthOnLarge: '22rem',
      items: [
        {
          label: 'Доставка и плащане',
          url: '/delivery-payment',
        },
        {
          label: 'Проверка на пратката преди плащане',
          url: '/proverka-na-pratkata-predi-zaplashtane',
        },
        {
          label: 'Общи условия',
          url: '/terms-and-conditions',
        },
        {
          label: 'Политика за връщане на стоки',
          url: '/politika-za-vrushtane-na-stoka',
        },
        {
          label: 'Политика за поверителност',
          url: '/politika-za-poveritelnost',
        },
        {
          label: 'Менажирай бисквитките',
          url: '#cookies',
        },
        {
          label: 'Указания за упражняване на правото на отказ',
          url: '/prilozhenie-1',
        },
        {
          label: 'Стандартен формуляр за отказ',
          url: '/prilozhenie-2',
        },
        {
          label: 'Платформа за OPC',
          url: '/platforma-za-opc',
        },
      ],
    },
    {
      label: 'Продукти',
      url: '#',
      isCentered: true,
      footerImageLinks: [
        {
          url: '/akciq/c',
          image:
            'https://production.hippoland-contents.com/platform/media/hippo-akcia-11173.png',
        },
      ],
      items: [
        {
          label: 'Най-ново',
          url: '/naj-novo/c',
        },
        {
          label: 'Марки',
          url: '/brands',
        },
        {
          label: 'Топ Оферти',
          url: '/top-oferti/c',
        },
        {
          label: 'От ТВ реклами',
          url: '/produkti-ot-tv-reklami/c',
        },
      ],
      additionalImages: [
        {
          url: '/hippo-plus',
          image: 
            'https://production.hippoland-contents.com/platform/media/Method Draw Image-60b099f760fa9f00192dece0.png',
        }
      ]
    },
  ],
  contactMenu: {
    label: 'Последвайте ни',
    socialItems: [
      {
        media: 'facebook',
        url: 'https://www.facebook.com/hippoland.bg',
      },
      {
        media: 'youtube',
        url: 'https://www.youtube.com/user/hippobg',
      },
      {
        media: 'instagram',
        url: 'https://www.instagram.com/hippolandstores/',
      },
    ],
  },
  bottomStrip: [
    {
      text: `© ${new Date()
        .getFullYear()
        .toString()} Hippoland.net. Всички права запазени`,
    },
  ],
  labels: {
    newsletterSubscribeSuccess: 'Успешно се абонирахте за нашия блюлетин',
    subscribeCallToAction: 'АБОНИРАЙ СЕ',
    securePaymentWith: 'Сигурно плащане с',
    logisticPartners: 'Логистични партньори',
    mandatoryField: 'Полето е задължително',
    invalidEmail: 'Невалиден имейл',
    enterEmail: 'Въведете имейл',
    newsletterEmailLabel: 'Бюлетин за персонализирани оферти и промоции',
  },
}
